module.exports = "/_next/static/images/20218a9c37a4c375d8e22dac42d5124b-woman-playing-with-her-kids@xl.jpg.webp";